import { makeStyles, Theme } from '@material-ui/core';

import { monochrome } from '../../../theme/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  selector: {
    height: '100%',
    '& .MuiInputBase-input': {
      paddingTop: 10,
    },
  },
  circle: {
    width: '12px',
    height: '12px',
    borderRadius: '50%',
  },
  count: {
    fontWeight: 600,
    textWrap: 'nowrap',
  },
  primaryBorder: {
    backgroundColor: theme.palette.primary.main,
  },
  warningBorder: {
    backgroundColor: theme.palette.warning.main,
  },
  neutralBorder: {
    backgroundColor: monochrome.mediumdark,
  },
  errorBorder: {
    backgroundColor: monochrome.mediumlight,
  },
  selectInput: {
    '& .MuiMenuItem-root': {
      borderBottom: 'unset',
    },
  },
  smallText: {
    fontSize: '13px',
    lineHeight: '22px',
  },
  barText: {
    fontSize: 15,
    fontWeight: 500,
    lineHeight: '22px',
    fill: theme.palette.text.primary,
  },
  lightText: {
    fill: monochrome.lightest,
  },

  tooltip: {
    display: 'flex',
    background: theme.palette.background.paper,
    padding: '4px 8px',
    borderRadius: '8px',
  },
}));
